import { Message } from "element-ui";
import Clipboard from 'clipboard';
import { i18n } from '@/i18n';
export default function handleClipboard(text,event) {
  // text:this.debugReturn
  const clipboard =  new Clipboard(
		event.target,
		{text:()=>text}
	)
	if(!text) {
		Message({
			type: 'error',
			message: i18n.t('device.copy_val_no')
	  });
		return;
	}
  clipboard.on('success', ()=> {
    Message({
        type: "success",
        message: i18n.t('device.copy_val_yes')
    });
    clipboard.destroy();
  });
  clipboard.on('error', ()=> {
    Message({
        type: 'error',
        message: i18n.t('device.copy_val_no')
    });
    clipboard.destroy();
  })
  clipboard.onClick(event);
}